import angular from "angular"
const templateUrl = require("ngtemplate-loader!html-loader!./usuario.component.html")

UsuarioComponent.$inject = [
  "AlertaService",
  "AlertaListService",
  "EventoService",
  "EventoListService",
  "PeriodoService"
]
function UsuarioComponent(
  AlertaService,
  AlertaListService,
  EventoService,
  EventoListService,
  PeriodoService
) {
  var self = this
  self.modelName = "atenciones"
  self._columns = [
    {
      key: "categoria",
      value: "categoría"
    },
    {
      key: "plan_accion",
      value: "plan de acción"
    },
    {
      key: "tarea",
      value: "atención"
    },
    {
      key: "estado_desc",
      value: "estado actual"
    },
    {
      key: "alumno_cedula",
      value: "cédula estudiante"
    },
    {
      key: "alumno",
      value: "estudiante"
    },
    {
      key: "asistencia_desc",
      value: "asistencia"
    },
    {
      key: "fecha_limite",
      value: "fecha límite"
    },
    {
      key: "creador",
      value: "ingresado por"
    }
  ]
  self.menuOptions = [
    {
      name: "Finalizar Atención",
      callback: "goToAttentionDetail"
    },
    {
      name: "Ver Ficha",
      callback: "goToStudentProfile"
    }
  ]
  self.crudMenu = [
    {
      action: "estado",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "asistencia",
      icon_name: "check",
      callback: "editModels"
    }
  ]

  self.onEdit = function(models) {
    return EventoService.update(models).$promise.then(function() {
      return { status: true }
    })
  }

  self.onDelete = function(models) {
    return EventoService.remove({ "ids[]": models }).$promise
  }

  self._getModels = function(tableName, offset) {
    if (tableName === "agenda") {
      return PeriodoService.get_periodo_actual().then(function(periodo_activo) {
        return EventoListService.query({
          periodo_id: periodo_activo.id,
          limit: 50,
          offset: offset
        }).$promise
      })
    }
  }

  //#################################################

  self.modelNameAlerta = "alertas"

  self._columnsAlerta = [
    {
      key: "tipo_alerta",
      value: "tipo de alerta"
    },
    {
      key: "estado",
      value: "estado actual"
    },
    {
      key: "alumno_cedula",
      value: "rut"
    },
    {
      key: "alumno",
      value: "alumno"
    },
    {
      key: "fecha_ingreso",
      value: "fecha de ingreso"
    },
    {
      key: "creador",
      value: "ingresado por"
    }
  ]

  self.menuOptionsAlerta = [
    {
      name: "Ver Alerta",
      callback: "goToAlertDetail"
    },
    {
      name: "Ver Ficha",
      callback: "goToStudentProfile"
    }
  ]

  self.crudMenuAlerta = [
    {
      action: "estado",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onEditAlerta = function(models) {
    return AlertaService.update(models).$promise.then(function() {
      return { status: true }
    })
  }

  self.onDeleteAlerta = function(models) {
    return AlertaService.remove({ "ids[]": models }).$promise
  }

  self._getModelsAlerta = function() {
    return PeriodoService.get_periodo_actual().then(function(periodo_activo) {
      return AlertaListService.query({
        periodo_id: periodo_activo.id,
        limit: 50
      }).$promise
    })
  }
}

angular.module("appModule").component("usuario", {
  templateUrl: templateUrl,
  bindings: {},
  controller: UsuarioComponent
})
